(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function fullResolutionUrl(src) {
    return src || '';
  }

  function initGallery(root) {
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-media-panel]'));
    var index = root.querySelector('[data-gallery-index]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-electro-thumb]'));
    if (!panels.length || !thumbs.length) return;
    function selectThumb(thumb, focus) {
      thumbs.forEach(function (item) {
        var selected = item === thumb;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-checked', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var selected = panel.dataset.mediaId === thumb.dataset.mediaId;
        panel.hidden = !selected;
        if (!selected) panel.querySelectorAll('video').forEach(function (video) { video.pause(); });
      });
      if (index) index.textContent = String(thumbs.indexOf(thumb) + 1);
      if (focus) thumb.focus();
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { selectThumb(thumb, false); });
      thumb.addEventListener('keydown', function (event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        var current = thumbs.indexOf(thumb);
        var next = event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : event.key === 'ArrowRight' ? (current + 1) % thumbs.length : (current - 1 + thumbs.length) % thumbs.length;
        selectThumb(thumbs[next], true);
      });
    });
    var initiallySelected = thumbs.find(function (thumb) { return thumb.getAttribute('aria-checked') === 'true'; }) || thumbs[0];
    selectThumb(initiallySelected, false);
    root.addEventListener('gpuelite:variant-change', function (event) {
      var mediaId = String(event.detail && event.detail.featuredMediaId || '');
      var match = thumbs.find(function (thumb) { return thumb.dataset.mediaId === mediaId; });
      if (match) selectThumb(match, false);
    });
  }

  function initVariantStatus(root) {
    var json = root.querySelector('[data-product-json]');
    var form = root.querySelector('.r4-product-form');
    var status = root.querySelector('[data-electro-variant-status]');
    if (!json || !form || !status) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (error) { return; }

    function selectedVariant() {
      var idInput = form.querySelector('input[name="id"]');
      var currentId = idInput ? Number(idInput.value) : 0;
      if (currentId) {
        var byId = product.variants.find(function (variant) { return Number(variant.id) === currentId; });
        if (byId) return byId;
      }
      var selected = product.options.map(function (name) {
        if (name === 'Title' && product.variants.length === 1) return product.variants[0].options[0];
        var input = form.querySelector('input[name="options[' + CSS.escape(name) + ']"]:checked');
        return input ? input.value : null;
      });
      return product.variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === selected[index]; });
      }) || null;
    }

    var productSoldOut = !(product.variants || []).some(function (variant) { return variant.available; });
    function update() {
      window.requestAnimationFrame(function () {
        var variant = selectedVariant();
        if (!variant) status.textContent = 'This option combination is unavailable.';
        else if (!variant.available) status.textContent = productSoldOut ? 'Product is sold out.' : 'Selected option is unavailable.';
        else status.textContent = 'Selected option is available.';

      });
    }

    form.querySelectorAll('.r4-variant-group input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  }

  function initSpecExplorer(root) {
    var explorer = root.querySelector('[data-spec-explorer]');
    if (!explorer) return;
    var input = explorer.querySelector('[data-spec-search]');
    var status = explorer.querySelector('[data-spec-status]');
    var summary = explorer.querySelector('[data-spec-summary]');
    var empty = explorer.querySelector('[data-spec-empty]');
    var clear = explorer.querySelector('[data-spec-clear]');
    var tableWrap = explorer.querySelector('[data-spec-table-wrap]');
    var rows = Array.prototype.slice.call(explorer.querySelectorAll('[data-spec-table] tr:not(.r9-spec-section)'));
    var groups = Array.prototype.slice.call(explorer.querySelectorAll('.r9-spec-section'));
    if (summary && rows.length) summary.textContent = rows.length + ' available attributes, grouped for quick review.';
    var jumpCount = root.querySelector('[data-spec-jump-count]');
    if (jumpCount && rows.length) jumpCount.textContent = rows.length + (rows.length === 1 ? ' verified product attribute' : ' verified product attributes');
    if (!input || !rows.length) return;

    function updateSpecifications() {
      var query = input.value.trim().toLocaleLowerCase();
      var visible = 0;
      rows.forEach(function (row) {
        var match = !query || row.textContent.toLocaleLowerCase().includes(query);
        row.hidden = !match;
        if (match) visible += 1;
      });
      groups.forEach(function (group) {
        var next = group.nextElementSibling;
        var hasVisibleRow = false;
        while (next && !next.classList.contains('r9-spec-section')) {
          if (!next.classList.contains('r9-spec-section') && !next.hidden) hasVisibleRow = true;
          next = next.nextElementSibling;
        }
        group.hidden = !hasVisibleRow;
      });
      if (status) status.textContent = query ? visible + (visible === 1 ? ' matching attribute' : ' matching attributes') : '';
      if (empty) empty.hidden = visible !== 0;
      if (tableWrap) tableWrap.hidden = visible === 0;
    }
    input.addEventListener('input', updateSpecifications);
    if (clear) clear.addEventListener('click', function () {
      input.value = '';
      updateSpecifications();
      input.focus();
    });
  }

  function initSpecJump(root) {
    var jump = root.querySelector('[data-spec-jump]');
    if (!jump) return;
    jump.addEventListener('click', function (event) {
      var tab = root.querySelector('[data-pdp-tab-slug="specifications"]');
      var panel = root.querySelector(jump.getAttribute('href'));
      if (!tab || !panel) return;
      event.preventDefault();
      tab.click();
      panel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      window.setTimeout(function () {
        var search = panel.querySelector('[data-spec-search]');
        if (search) search.focus({ preventScroll: true });
      }, 250);
    });
  }

  function openSpecifications(root, trigger) {
    var tab = root.querySelector('[data-pdp-tab-slug="specifications"]');
    var panel = tab && document.getElementById(tab.getAttribute('aria-controls'));
    if (!tab || !panel) return;
    tab.click();
    panel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    window.setTimeout(function () {
      var search = panel.querySelector('[data-spec-search]');
      (search || tab).focus({ preventScroll: true });
    }, 250);
    if (trigger) trigger.setAttribute('aria-describedby', panel.id);
  }

  function initContentActions(root) {
    root.querySelectorAll('[data-open-specifications]').forEach(function (button) {
      button.addEventListener('click', function () { openSpecifications(root, button); });
    });
    var compareLink = root.querySelector('[data-focus-compare-control]');
    var compareButton = root.querySelector('.electro-pdp__buy [data-compare-toggle]');
    if (compareLink && compareButton) {
      compareLink.addEventListener('click', function (event) {
        event.preventDefault();
        compareButton.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        compareButton.focus({ preventScroll: true });
      });
    }
  }

  function initQuantity(root) {
    var control = root.querySelector('[data-quantity-control]');
    if (!control) return;
    var input = control.querySelector('input[name="quantity"]');
    if (!input) return;
    control.querySelectorAll('[data-quantity-change]').forEach(function (button) {
      button.addEventListener('click', function () {
        var min = Number(input.min || 1);
        var max = Number(input.max || 99);
        var next = Math.max(min, Math.min(max, Number(input.value || min) + Number(button.dataset.quantityChange || 0)));
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initImageFallback(root) {
    root.querySelectorAll('[data-electro-main-image]').forEach(function (image) {
      image.addEventListener('error', function () {
        var panel = image.closest('[data-media-panel]');
        if (!panel || panel.querySelector('.electro-pdp__no-media')) return;
        var fallback = document.createElement('div');
        fallback.className = 'electro-pdp__no-media';
        fallback.setAttribute('role', 'img');
        fallback.setAttribute('aria-label', 'Product image unavailable');
        fallback.innerHTML = '<span aria-hidden="true">◇</span><strong>Image unavailable</strong><small></small>';
        fallback.querySelector('small').textContent = image.dataset.imageFallbackTitle || 'Product image';
        panel.replaceChildren(fallback);
      }, { once: true });
    });
  }

  function initRecommendations(root) {
    var host = root.querySelector('[data-product-recommendations]');
    if (!host || !host.dataset.recommendationsUrl) return;
    fetch(host.dataset.recommendationsUrl, { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        if (!html.trim()) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.electro-pdp__related');
        if (section && section.querySelector('[data-product-card]')) host.replaceChildren(section);
      })
      .catch(function () { /* Recommendations are enhancement-only. */ });
  }

  ready(function () {
    var root = document.querySelector('[data-electro-pdp]');
    if (root) {
      initGallery(root);
      initVariantStatus(root);
      initSpecExplorer(root);
      initSpecJump(root);
      initContentActions(root);
      initQuantity(root);
      initImageFallback(root);
      initRecommendations(root);
    }

  });
})();
